import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  limit: null,
  storeId: null,
  brandCd: null,
  keyword: "",
  sortType: null,
  loading: false,
  loaded: null,
  data: null,
  productList: [],
  brandId: null,
  total: null,
  infinity: true, // 무한스크롤 활성 상태
  areaCode: null,
};

// Slice
const productSearchSlice = createSlice({
  name: "productSearch",
  initialState,
  reducers: {
    initProduct(state) {
      return {
        ...state,
        limit: null,
        storeId: null,
        brandCd: null,
        keyword: null,
        sortType: null,
        loading: false,
        loaded: null,
        data: null,
        productList: [],
        brandId: null,
        total: null,
        infinity: true,
        areaCode: null,
      };
    },
    findProduct(state) {
      return {
        ...state,
        productList: [],
        loading: true,
        error: false,
        loaded: false,
        infinity: true,
      };
    },
    findMoreProduct(state) {
      return { ...state, loading: true, error: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setProductList(state, action) {
      const { data, total, brandId, storeId, keyword, areaCode } =
        action.payload;
      return {
        ...state,
        productList: [...state.productList, ...data],
        total,
        brandId,
        storeId,
        keyword,
        areaCode,
      };
    },
    sefInfinity(state) {
      return {
        ...state,
        infinity: false,
      };
    },
  },
});

export const {
  initProduct,
  findProduct,
  findMoreProduct,
  fetchDataSuccess,
  fetchDataFailure,
  setProductList,
  sefInfinity,
} = productSearchSlice.actions;

export default productSearchSlice.reducer;

//saga
function* fetchDataSaga(action) {
  try {
    const currentDataLength = yield select(
      (state) => state.productSearch.productList.length
    );
    const total = yield select((state) => state.productSearch.total);
    const peerIp = yield select((state) => state.peerIp.ip);
    if (total !== null && currentDataLength >= total && total !== 0) {
      // 이미 모든 데이터를 불러왔을 경우, 추가 요청하지 않음
      yield put(sefInfinity());
      return;
    }

    const {
      headers = {},
      apiUrl,
      brandId,
      storeId,
      keyword,
      areaCode,
    } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { data, total } = response.data;
      // const { data, total } = datas;
      yield put(
        setProductList({ data, total, brandId, storeId, keyword, areaCode })
      );
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* productSearchSaga() {
  yield takeLatest(findProduct.type, fetchDataSaga);
  yield takeLatest(findMoreProduct.type, fetchDataSaga);
}
